import {Container} from '@mui/material';
import {useNavigate} from '@tanstack/react-router';
import {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import DismissibleAlert from '../DismissibleAlert.tsx';
import SignInForm from '../Forms/SignInForm';
import {type JWTUser, JWT_STORAGE_KEY} from '../Providers/JWTProvider';

type Props = {
    authenticate: (username: string, password: string) => Promise<JWTUser | null>;
};

const SignIn = ({authenticate}: Props) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState<boolean>(false);

    const handleSignInSubmit = useCallback(
        async (values: {username: string; password: string}) => {
            let user: JWTUser | null = await authenticate(values.username, values.password);
            setShowAlert(false);

            if (
                import.meta.env.VITE_REACT_APP_ENABLE_JWT_OVERRIDE &&
                import.meta.env.VITE_REACT_APP_ADMIN_JWT
            ) {
                user = {accessToken: import.meta.env.VITE_REACT_APP_ADMIN_JWT};
                localStorage.setItem(JWT_STORAGE_KEY, JSON.stringify(user));
            }

            if (user) {
                void navigate({to: '/admin/dashboard'});
            } else {
                setShowAlert(true);
            }
        },
        [authenticate, navigate],
    );

    return (
        <>
            <Container
                maxWidth='sm'
                sx={{backgroundColor: '#fff', p: 2, mt: 2, borderRadius: '8px'}}
            >
                <DismissibleAlert
                    showAlert={showAlert}
                    setShowAlert={setShowAlert}
                    message={t('errorLogin')}
                />
                <SignInForm handleSignInSubmit={handleSignInSubmit} />
            </Container>
        </>
    );
};

export default SignIn;
